import { render, staticRenderFns } from "./accountMoney.vue?vue&type=template&id=74f40ee1"
import script from "./accountMoney.vue?vue&type=script&lang=js"
export * from "./accountMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports